import { getWeightedCompValue } from "lib/shared/users/getWeightedCompValue";
import { FieldType, WeightedComp } from "prisma/cm/client";

import { FieldDefinition, UsageModel } from "../../fieldDefinition";
import { FieldValueResolver } from "../../FieldValueResolver";
import { FieldSourceType } from "../../types";

export function fromWeightedComp(weightedComp: WeightedComp): FieldDefinition {
  return new FieldDefinition({
    id: weightedComp.id,
    baseModel: UsageModel.User,
    fieldSourceType: FieldSourceType.WEIGHTED_COMP,
    valueGetter: (user) => {
      if (!FieldValueResolver.validateAsUser(user)) {
        return null;
      }

      return getWeightedCompValue(user, weightedComp.id);
    },
    label: weightedComp.name,
    fieldTypes: [FieldType.DOLLAR],
  });
}
